/**
 * Optimizely integration functionality
 * Replicates the logic from Adobe Launch OptimizelyExperimentData data element
 */ import { getCookie, isHardLoggedIn } from './utils';
/**
 * Extract Optimizely experiment data from cookies
 * Replicates the logic from Adobe Launch OptimizelyExperimentData data element
 */ export function getOptimizelyExperimentData() {
    const experimentData = [];
    try {
        // Determine which cookie to read based on authentication state
        const cookieName = isHardLoggedIn() ? 'opt-user-profile' : 'opt-user-profile_mlp';
        let cookieValue = getCookie(cookieName);
        if (!cookieValue) {
            return experimentData;
        }
        // Double URL decode the cookie value (matching Adobe Launch logic)
        let previousValue = '';
        try {
            // Keep decoding until no further changes occur
            while(previousValue !== cookieValue && cookieValue){
                previousValue = cookieValue;
                cookieValue = decodeURIComponent(cookieValue);
            }
        } catch (error) {
            console.error('Error decoding Optimizely cookie:', error);
            return experimentData;
        }
        const decodedValue = cookieValue || '';
        if (decodedValue) {
            const segments = decodedValue.split(',');
            // Skip the first segment and process the rest (matching Adobe Launch logic)
            segments.slice(1).forEach((segment)=>{
                if (segment) {
                    const parts = segment.split(':');
                    const experimentId = parts[0] || 'unknown';
                    const variationId = parts[1] || 'none';
                    if (experimentId && variationId) {
                        experimentData.push({
                            experimentId,
                            variationId
                        });
                    }
                }
            });
        }
        return experimentData;
    } catch (error) {
        console.error('An unexpected error occurred extracting Optimizely data:', error);
        return experimentData;
    }
}
